/// <amd-module name="Wit/BoardsHub/Common/Interfaces" />

import { IObservableArray, IObservableValue } from "VSS/Core/Observable";
import { ExternalLinkedArtifactIdentifier } from "Wit/Clients/Internal/Contracts/WorkItemTracking";
import { IClientWorkItem, IObservableClientWorkItem } from "Wit/ClientWorkItemService/IClientWorkItem";

/**
 * Info for the little annotation icons that show up at the bottom of cards.
 */
export interface IBoardsWorkItem extends IClientWorkItem {
    annotations: IItemAnnotations | undefined;
    isTitleEditing: IObservableValue<boolean>;
}

export interface IObservableBoardsWorkItem extends IObservableClientWorkItem<IBoardsWorkItem> {
    expandedAnnotation?: string;
    addingAnnotation?: boolean;
    setOpenAnnotation: (annotationName?: string, adding?: boolean) => void;
}

export interface IItemAnnotations {
    gitHub?: IGitHubAnnotationInfo;
    checklist?: IChecklistAnnotationInfo;
    tests?: ITestAnnotationInfo;
}
export interface IGitHubAnnotationInfo {
    commits: number;
    issues: number;
    pullRequests: number;
    links: ExternalLinkedArtifactIdentifier[];
}

export interface IChecklistAnnotationInfo {
    [type: string]: IChecklistAnnotationTypeInfo;
}

export interface IChecklistAnnotationTypeInfo {
    items: IObservableArray<IChecklistItem>;
}

export interface IChecklistItem {
    completed: boolean;
    id: number;
    order?: number;
    title: string;
    saving: IObservableValue<boolean>;
    state: string;
    type: string;
    assignedTo?: string;
}

export interface ITestAnnotationInfo {
    failed: number;
    notApplicable: number;
    other: number;
    passed: number;
    suiteId: number;
    planId: number;
    tests: IObservableArray<ITestItem>;
}

export const enum TestOutcome {
    Active = "Active",
    Passed = "Passed",
    Failed = "Failed",
    Blocked = "Blocked",
    NotApplicable = "NotApplicable",
    Paused = "Paused",
    InProgress = "InProgress"
}

export interface ITestItem {
    id: number;
    outcome: TestOutcome;
    sequenceNumber?: number;
    testPointId?: number;
    title: string;
}
